import type {
  FirestoreSupplierDocument,
  Supplier,
} from "@dashboard/types/supplier";

// Converts a firestore supplier document to a supplier object
export const readSupplier = (doc: FirestoreSupplierDocument): Supplier => {
  const { createdAt, modifiedAt, ...supplierRest } = doc;

  const supplier: Supplier = {
    ...supplierRest,
    createdAtMillis: createdAt.toMillis(),
    modifiedAtMillis: modifiedAt.toMillis(),
  };

  return supplier;
};
